// Module
var code = "<div class=\"top-section\"></div> <div class=\"bottom-section\"> <div class=\"left-side-bar\"></div> <div class=\"content\"></div> </div> ";
// Exports
export default code;